import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import Translation from '@swf/components/Translation/Translation';
import { Site } from '@swf/core/enums';
import { select } from '@swf/core/store';
import { ArticleList } from '@swf/help';

import type { Article, Category } from '../../types';

import {
  TXTWCL_Login_for_personalised_help,
  TXTWCL_Most_Viewed_Articles,
  TXTWCL_Recommended_for_You
} from './Home.messages.json';
import styles from './Home.scss';
import CategoryBoard from './components/CategoryBoard/CategoryBoard';
import LogIn from './components/LogIn/LogIn';

interface Props {
  categories?: Category[];
  articles?: Article[];
  recomended?: Article[];
}

const Home: React.FC<Props> = ({ categories, articles = [], recomended = [] }) => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);
  const articleList = articles.slice(0, 6);
  const isEmbedded = useSelector(select.site.isEmbedded);
  const site = useSelector(select.site.getId);
  const hideLogin = isEmbedded || isAuthenticated || site === Site.CH;

  return (
    <>
      <section>
        <div
          className={classNames(styles.contentWrapper, {
            [styles.horizontalWrapper]: !isAuthenticated
          })}
        >
          {isAuthenticated && (
            <div>
              {!!recomended.length && (
                <>
                  <h2 className={styles.title}>
                    <Translation {...TXTWCL_Recommended_for_You} />
                  </h2>
                  <ArticleList articles={recomended} highlight />
                </>
              )}
            </div>
          )}
          {!hideLogin && (
            <div className={styles.loginWrapper}>
              <h2 className={styles.title}>
                <Translation {...TXTWCL_Login_for_personalised_help} />
              </h2>
              <LogIn />
            </div>
          )}
          <div className={styles.articles}>
            <h1 className={classNames(styles.title, styles.articleTitle)}>
              <Translation {...TXTWCL_Most_Viewed_Articles} />
            </h1>
            <ArticleList
              articles={articleList}
              column={hideLogin ? 2 : 1}
              listOnMobile={isAuthenticated}
            />
          </div>
        </div>
      </section>
      <section>
        <CategoryBoard categories={categories} />
      </section>
    </>
  );
};

export default Home;
